export const snakeToLabel = (key: string): string => {
  const [first, second] = key.split('_')
  return `${first[0].toUpperCase()}${first.slice(1)}${second ? ` ${second.toLowerCase()}` : ''}`
}
